import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { Season } from '../../models';
import { AuthService } from '../../service/auth.service';
import { EcomicService } from '../../service/comics/ecomic.service';

@Component({
  selector: 'app-add-wis-season',
  templateUrl: './add-wis-season.component.html',
  styleUrls: ['./add-wis-season.component.css']
})
export class AddWisSeasonComponent implements OnInit {
  wisSeasonForm: FormGroup;
  loading: boolean = false;
  load: boolean = false;
  id: any;
  status: any = true;
  season: any = true;
  user: any;
  quater: any = true;

  thumbnail_image: File;
  cover_image: File;
  sponsor_image_Web_file: File;
  sponsor_image_APP_file: File;
  thumbnail_image_url: any;
  cover_image_url: any;
  sponsor_image_web: any;
  sponsor_image_app:any;
  coverimageerror: any = false;
  thumbnailimageerror: any = false;
  sponsorimageApperror: any = false;
  sponsorimageWeberror: any = false;
  IsAllowPointsPurchase = false;
  constructor(private form: FormBuilder, private router: Router, private auth: AuthService,
    private afs: AngularFirestore, private comicService: EcomicService, private route: ActivatedRoute ,
     public toastr: ToastsManager,vcr: ViewContainerRef  ) {
    this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {
    this.auth.getuser().then(userdetails => {
      this.user = userdetails;
    });
    this.wisSeasonForm = this.form.group({
      season_title: ['', [Validators.required]],
      season_description: ['', [Validators.required]],
      about_writers: ['', [Validators.required]],
      IsAllowPointsPurchase:["false",[Validators.required]],
      thumbnail_image: ['', []],
      cover_image: ['', []],
      sponsor_image_app: ['', []],
      sponsor_image_web: ['', []],
      sponsor_url: ['', [Validators.required]],
      status: ['InActive', [Validators.required]],
      season: ['Season 1', [Validators.required]],
      season_quarter: ['1', [Validators.required]],
      on_going_series:['false', [Validators.required]],
    });
    // getting the available eseries from the database
          this.route.paramMap.subscribe(params => {
            this.id =params.get('id');
            if (this.id) {
              this.status = false;
              this.season = false;
              this.quater  = false;
              this.comicService.getsinglecomic(this.id, 'WISSeason').then(data => {
                // const admindata = data.valueChanges();
                data.subscribe(singleseries => {
                  console.log(singleseries)
                  const singleadmin = singleseries;
                  this.wisSeasonForm.get('season_title').setValue(singleadmin['season_title']);
                  this.wisSeasonForm.get('season_description').setValue(singleadmin['season_description']);
                  // this.wisSeasonForm.get('seo_title').setValue(singleadmin['seo_title']);
                  // this.wisSeasonForm.get('seo_description').setValue(singleadmin['seo_description']);
                  // this.wisSeasonForm.get('seo_keyword').setValue(singleadmin['seo_keyword']);
                  this.wisSeasonForm.get('sponsor_url').setValue(singleadmin['sponsor_url']);
                  this.wisSeasonForm.get('season_quarter').setValue(singleadmin['season_quarter']);
                  this.wisSeasonForm.get('status').setValue(singleadmin['status']);
                  this.wisSeasonForm.get('season').setValue(singleadmin['season']);
                  this.wisSeasonForm.get('IsAllowPointsPurchase').setValue(singleadmin['IsAllowPointsPurchase']);
                  this.wisSeasonForm.get('about_writers').setValue(singleadmin['about_writers']);
                  this.wisSeasonForm.get('on_going_series').setValue(singleadmin['on_going_series'] ? singleadmin['on_going_series'] : 'false');
                  this.thumbnail_image_url = singleseries['thumbnail_image'];
                  this.cover_image_url = singleseries['cover_image'];
                  this.sponsor_image_web = singleseries['sponsor_image_web'];
                  this.sponsor_image_app = singleseries['sponsor_image_app'];
                  this.status = true;
                  this.season = true;
                  this.quater  = true;
                });
              });
            }
          });
  
  }

  async addseason(value, valid) {
    if (valid) {
      this.loading = true;
      console.log(value)
      const season: Season = {
        about_writers :value.about_writers,
        season_title: value.season_title,
        season_description: value.season_description,
        sponsor_url: value.sponsor_url,
        season_quarter: value.season_quarter,
        season: value.season,
        status: value.status,
        reads: 0,
        on_going_series:value.on_going_series
      };
      try {
        if (this.id) {
          let thumbnail;
          let coverimage;
          let sponsorimgWeb;
          let sponsorImgApp;
          // Checking if the cover image is changed if changed the update the image in sapces and also db.
          if (this.cover_image) {
            coverimage = await this.auth.uploadimage('wis/thumbnail/', this.cover_image, false);
            season.cover_image = coverimage['Location'];
          }
          // Checking if the thumbnail image is changed if changed the update the image in sapces and also db.
          if (this.thumbnail_image) {
            thumbnail = await this.auth.uploadimage('wis/cover/', this.thumbnail_image, false);
            season.thumbnail_image = thumbnail['Location'];
          }
          if (this.sponsor_image_Web_file) {
            sponsorimgWeb = await this.auth.uploadimage('wis/sponsor/', this.sponsor_image_Web_file, false);
            season.sponsor_image_web = sponsorimgWeb['Location'];
          }
          if (this.sponsor_image_APP_file) {
            sponsorImgApp = await this.auth.uploadimage('wis/sponsor/', this.sponsor_image_APP_file, false);
            season.sponsor_image_app = sponsorImgApp['Location'];
          }
          season.IsAllowPointsPurchase = JSON.parse(this.wisSeasonForm.value.IsAllowPointsPurchase);
          const document = await this.afs.doc(`/WISSeason/${this.id}`);
          const update = await document.update(season);

          this.toastr.success('Webnnel Insta Season Updated!', 'Success!');
          
          setTimeout(() => {
            this.router.navigate(['/wis-season']);
          }, 2000);
        } else {
          if (!this.thumbnail_image) { this.thumbnailimageerror = true; this.loading = false; return false; }
          if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
          if (!this.sponsor_image_Web_file) { this.sponsorimageWeberror = true; this.loading = false; return false; }
          if (!this.sponsor_image_APP_file) { this.sponsorimageApperror = true; this.loading = false; return false; }
          // uploading the images to the spaces and getting the uoloaded location
          const thumbnail = await this.auth.uploadimage('wis/thumbnail/', this.thumbnail_image, false);
          const coverimage = await this.auth.uploadimage('wis/cover/', this.cover_image, false);
          const sponsorimageWeb = await this.auth.uploadimage('wis/sponsor/', this.sponsor_image_Web_file, false);
          const sponsorimageApp = await this.auth.uploadimage('wis/sponsor/', this.sponsor_image_APP_file, false);

          season.thumbnail_image = thumbnail['Location'];
          season.sponsor_image_web = sponsorimageWeb['Location'];
          season.sponsor_image_app = sponsorimageApp['Location'];
          season.cover_image = coverimage['Location']
          season.pricing_type = 'Free';
          season.admin = this.user.uid;
          season.addedby = this.user.username;
          season.rating = [0, 0, 0, 0, 1];
          season.createdAt = new Date();
          season.date = new Date().toString();
          season.IsAllowPointsPurchase = JSON.parse(this.wisSeasonForm.value.IsAllowPointsPurchase);
          const eseasondata = await this.afs.collection('WISSeason').add(season);
          const esid = eseasondata.id;
          const id = await this.afs.doc(`/WISSeason/${esid}`).update({ id: esid });
          this.toastr.success('Webnnel Insta Season Added!', 'Success!');
          
          setTimeout(() => {
            this.router.navigate(['/wis-season']);
          }, 2000);
        }
      } catch (error) {
        this.loading = false;
        this.load = true;
        this.toastr.error('Somthing went wrong please try later!', 'Oops!');
        console.log(error);
      }
    } else {
      console.log('error');
      this.toastr.error('Somthing went wrong please try later!', 'Oops!');
    }
  }

  changeListner1(event) {
    if (event.target.files && event.target.files[0]) {
      this.thumbnail_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.thumbnail_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner2(event) {
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }


  changeListner3(event) {
    if (event.target.files && event.target.files[0]) {
      this.sponsor_image_Web_file = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.sponsor_image_web = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }
  changeListner4(event) {
    if (event.target.files && event.target.files[0]) {
      this.sponsor_image_APP_file = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.sponsor_image_app = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/wis/add-wis-season/add-wis-season.component.ts